// @helpers
const { APIPost } = require('utilities/APIRequestHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { formatText } = require('core/i18n').i18n;

// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const notification = require('actions/notifications');

// @ constants
const actionTypes = require('constants/actionTypes');
const {
    FIRST_STEP,
    SECOND_STEP
} = require('constants/index');

const validateStep = (step) => {
    scrollToTop();
    return {
        type: actionTypes.EXTERNAL_TRANSFER_VALUES_VALIDATE_STEP,
        payload: {
            step
        }
    };
};

const setVisibleStep = (step) => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const resetState = () => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_RESET
});

const setWillCancel = (willCancel) => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const setDestinationAccount = (value, selectOptions) => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_SET_DESTINATION_ACCOUNT,
    payload: {
        value,
        selectOptions
    }
});

const setContractNumber = (contractNumber) => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_SET_CONTRACT_NUMBER,
    payload: {
        contractNumber
    }
});

const setBankName = (bankName) => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_SET_BANK_NAME,
    payload: {
        bankName
    }
});


const setNoOfProducts = (noOfProducts, productIndex) => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_SET_NO_OF_PRODUCTS,
    payload: {
        noOfProducts,
        productIndex
    }
});

const setBrokerSearchField = (product, productIndex) => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_SET_BROKER_SEARCH_INPUT_FIELD,
    payload: {
        product,
        productIndex
    }
});

const resetDuplicateError = (productIndex) => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_RESET_DUPLICATE_ERROR,
    payload: {
        productIndex
    }
});

const addAnotherProduct = () => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_ADD_PRODUCT_EMPTY_ROW
});

const undoDeletion = () => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_UNDO_DELETION
});

const deleteProductAction = (productIndex) => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_DELETE_PRODUCT,
    payload: {
        productIndex
    }
});

const deleteProduct = (productIndex, undoDeletion) => (dispatch) => {
    const message = formatText('externalTransferValues-externalTransferValues_snackbarMessage');
    dispatch(deleteProductAction(productIndex));
    if (typeof undoDeletion === 'function') {
        dispatch(notification.success({
            message,
            actionText: formatText('externalTransferValues-externalTransferValues_snackbarLink'),
            actionClickCallback: undoDeletion //Thunk connected action passed, routed through component's connect() function
        }, {voice: message}));
    }
}

const addFile = (fileState) => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_ADD_FILE,
    payload: {
        fileState
    }
});

const removeFile = () => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_REMOVE_FILE,
});

const externalTransferRequest = () => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_REQUEST
});

const externalTransferSuccess = (response) => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_SUCCESS,
    payload: {
        response
    }
});

const externalTransferError = (error) => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_ERROR,
    payload: {
        error
    }
});

const externalTransferUploadError = (error) => ({
    type: actionTypes.EXTERNAL_TRANSFER_VALUES_UPLOAD_ERROR,
    payload: {
        error
    }
});

const confirmExternalTransfer = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(externalTransferRequest());
        const immExternalTransferValues = getState().externalTransferValues;
        const immFirstStep = immExternalTransferValues.getIn(['steps', FIRST_STEP]);
        const bankName = immFirstStep.get('bankName');
        const originContract = immFirstStep.get('contractNumber');
        const associatedAccount = immFirstStep.getIn(['destinationAccountObject', 'associatedAccount']);
        const immSecondStep = immExternalTransferValues.getIn(['steps' , SECOND_STEP]);
        const immSelectedProductsArray = immSecondStep.get('selectedProductsArray');
        const numberOfTitlesArray = immSelectedProductsArray.map(productsRow => {
            return {[productsRow.getIn(['product', 'isin'])]: parseInt(productsRow.get('noOfProducts'))}
        }).toJS();
        const numberOfTitlesObject = Object.assign({}, ...numberOfTitlesArray);
        const isinNumbersArray = Object.keys(numberOfTitlesObject);
        const requestData = {
            query: {
                dataToken,
                destinationSecurityAcctNumber: associatedAccount,
                entityBankName: bankName,
                originSecurityAcctNumber: originContract,
                documentNoList: isinNumbersArray,
                isinandNumberOfTitles: numberOfTitlesObject
            }
        }

        return APIPost({
            dispatch,
            endpoint: 'brokerExternalValuesConfirmation',
            params: requestData
        }).then((response) => {
            const immProfile = getState().profile;
            const clientName = immProfile.get('nombreCliente');
            const clientSurname = immProfile.getIn(['apellidoUno', 'apellido']);
            const customerId = immProfile.getIn(['documentoIdentificacion', 'codigodocumpersonacorp']);
            const fileDataBase64 = immFirstStep.getIn(['filesAttached', 0, 'data', 'base64']);

            const requestData = {
                query: {
                    bankName,
                    ccvSelected: originContract,
                    associatedcco: associatedAccount,
                    clientName,
                    clientSurname,
                    customerId,
                    docBase64: fileDataBase64,
                    recordCode: response
                }
            }
            return APIPost({
                dispatch,
                endpoint: 'brokerExternalValuesUploadDocument',
                params: requestData
            })
            .then(response => dispatch(externalTransferSuccess(response)))
            .catch(error => dispatch(externalTransferUploadError(error)));
        })
        .catch((error => dispatch(externalTransferError(error))));
    }

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    addAnotherProduct,
    confirmExternalTransfer,
    deleteProduct,
    removeFile,
    resetState,
    resetDuplicateError,
    setBankName,
    setContractNumber,
    setDestinationAccount,
    setBrokerSearchField,
    setNoOfProducts,
    setVisibleStep,
    setWillCancel,
    validateStep,
    addFile,
    undoDeletion
};
